<template>
  <div>
    <vs-col vs-w="4" v-for="(item,index) in tienda" :key="index">
      <center>
        <img :src=getPath(item.imagen) style="height:200px"/> 
        <h5>{{item.descripcion}} </h5><br>
        <h5 style="color: #008fd3; font-style: italic;"><b>{{item.puntos.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}} VIVOCOINS</b></h5><br>
        <div v-if="item.puntos > puntosactuales">
          <vs-button color="success" type="filled" size="middle" icon="" disabled @click="Canjear(item.puntos);"> Canjear Ahora</vs-button><br><br>
        </div>
        <div v-else>
          
          <vs-button color="success" type="filled" size="middle" icon="" @click="Canjear(item.id,item.puntos);"> Canjear Ahora</vs-button><br><br>
        </div>
      </center>
    </vs-col>
  </div>
</template>
<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import flatPickr from 'vue-flatpickr-component'
import 'sweetalert2/dist/sweetalert2.min.css';
import Datepicker from 'vuejs-datepicker'
import axios from '../../axios.js'
import vSelect from 'vue-select'
import Vue from 'vue'
import VueSweetalert2 from 'vue-sweetalert2';
Vue.use(VueSweetalert2);
Vue.component('v-select', vSelect)
  export default {
    data () {
      return {
        tienda: [],
        pais: 0,
        puntosactuales: '',
      }
    },
    methods: {
      init(){
        this.openLoading();
        this.consultarInfo();
      },
      openLoading(){
        this.$vs.loading({type:'corners'});
      },
      closeLoading(){
        this.$vs.loading.close();
      },
      getPath(img){
         return this.$http.getImgPath(img);
      },
      getTienda(pais) {
        this.$http.post('Reward','getTienda',{pais},(data)=>{
          this.tienda = data;
        });
      }, 
      Canjear(producto_id,puntos){
        if(puntos>this.puntosactuales){
          this.$vs.notify({title:'Tienda',text:'No cuentas con los suficientes puntos para canjear.',color:'danger',icon:'close',time:4000});
        }else{
          this.$swal({
            title: "¿Estás seguro de canjear este producto?",
            icon: "info",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            cancelButtonText: "No",
            confirmButtonText: "Si",
          }).then(async (result) => {
            if (result.value) {
              this.$http.post('Reward','SaveCanjear',{producto_id,puntos},(data)=>{
                if(data>0){
                  this.consultarInfo();
                  this.EnviarEmail(data);
                }
              });
            }
          });
        }
      },
      EnviarEmail(pedido_id){
        this.openLoading();
        this.$http.post('Reward','EnviarPedido',{pedido_id},(data)=>{
          this.closeLoading();
          this.$swal.fire(
            'Rewards',
            'Tu pedido #'+pedido_id+' se encuentra en proceso de validación por parte de nuestro Mayorista.<br>En cuando se encuentre listo, recibirás un correo para notificarte la dirección de entrega y horario para recoger tus productos. <br>VIVOTEK AGRADECE TU CONFIANZA',
            'success'
          );
          this.$router.push('/tienda_pedidos').catch(() => {})
        });
      },
      consultarInfo(){
        this.$http.post('Empresas','consultarInfoPerfil',{},(data)=>{
          if(data){
            this.$store.state.AppActiveUser.displayPunt = data.puntos;
            this.puntosactuales = data.puntos;
            if(data.pais>0){
              this.getTienda(data.pais);
            }else{
              this.$router.push('/perfil').catch(() => { })
              this.$vs.notify({ title: 'Error', text: 'Para visualizar la tienda, por favor completa los datos de tu perfil.', color: 'danger', icon: 'close', time: 8000 });
            }
          }
          this.closeLoading();
        });
      },
    },
    mounted() {
      this.init();
    },
  }
</script>